<template>
  <div>
    <img
      class="mx-auto h-72 w-center"
      src="@//assets/icons/Slagboom-met-pijl.svg"
    />

    <card-title>Wat is de lengte van de slagboom?</card-title>
    <body-card> Om de toegang volledig af te sluiten vul je de totale breedte van de
      doorgang in. Als er voetgangers en fietsers mogen passeren, vul dan de
      breedte +/- 1 meter in. Rond altijd de doorgang af naar boven, voor een
      doorgang van 3,6 meter selecteer je 4 meter.</body-card>

    <fieldset class="flex flex-col my-3" id="lengte">
      <label
        v-for="option in this.pages[0]['options']"
        :key="option.price"
        :for="option.id"
        class="inline-flex items-center mt-3"
      >
        <input
          @click="setValueChild('stap-1', option.price, option.title)"
          :checked="option.selected == true"
          type="radio"
          :id="option.id"
          value="20"
          name="group2"
          class="
            form-radio
            h-5
            w-5
            text-primary
            checked:bg-primary checked:border-4
            bg-transparent
            border-primary border-2
          "
          
        /><span class="ml-2">{{ option.title }}</span>
      </label>
    </fieldset>

    <btn-group-bottom 
    previous="/" 
    next="stap-2" 
    :current="this.pages[0]['slug']" 
    @InlineButtonClickHandler="InlineButtonClickHandler"
    />
  
  </div>
</template>

<script>

export default {
  name: "Stap1",
  props: {
    pages: Array,
    totalPrice: Number,
  },
  methods: {
    data() {
      return {
        options: this.pages[1]["options"],
      };
    },
    addChild(i) {
      this.$emit("add", i);
    },
    InlineButtonClickHandler(current) {
      this.$emit("InlineButtonClickHandler", current);
    },
    removeChild(i) {
      this.$emit("remove", i);
    },
    setValueChild(key, value, title) {
      this.$emit("setValue", key, value, title);
    },
  },
  mounted: function () {
  },
  inheritAttrs: false, // disable 'non-props' warning
};
</script>
